import styles from "./ImageDetail.module.css";

function formatDateTime(input) {
  var epoch = new Date(0);
  epoch.setSeconds(parseInt(input));
  var date = epoch.toISOString();
  date = date.replace("T", " ");
  return date.split(".")[0].split(" ")[0];
}

const DiscriptionBottomSection = ({ details }) => (
  <div className="container-fluid p-3">
    <div className="row justify-content-between">
      <div className="col-12">
        <div className={styles.bottomSectionDescriptionSingle}>
          <span>Created By</span>
          <span className={styles.bottomSectionDetailsHighlight}>
            {details ? details.created_by : ""}
          </span>
        </div>
        <div className={styles.bottomSectionDescriptionSingle}>
          <span>Title:</span>
          <span>#{details ? details.title : ""}</span>
        </div>
        <div className={styles.bottomSectionDescriptionSingle}>
          <span>Created On:</span>
          <span>
            {details ? formatDateTime(details.created_on.seconds) : ""}
          </span>
        </div>
      </div>
    </div>
  </div>
);

export default DiscriptionBottomSection;
